// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 100vh;
  background: #f8f9fa;
  color: #191c1d;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.bc-page mat-icon {
  vertical-align: middle;
}

.bc-btn-primary mat-icon {
  color: #fff;
}

.bc-page {
  padding: 24px 16px 48px;
  max-width: 1152px;
  margin: 0 auto;
}

.bc-wrap {
  max-width: 100%;
}

.bc-header {
  margin-bottom: 32px;
}

.bc-title {
  font-family: "Manrope", "Inter", sans-serif;
  font-weight: 800;
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  letter-spacing: -0.02em;
  margin: 0 0 8px;
  color: #191c1d;
}

.bc-lead {
  margin: 0 0 16px;
  max-width: 42rem;
  font-size: 15px;
  line-height: 1.55;
  color: #40474f;
}

.bc-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  font-size: 14px;
}

.bc-meta__item {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
}

.bc-meta__k {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0b6397;
}

.bc-meta__v {
  font-weight: 600;
  color: #191c1d;
}

.bc-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  align-items: start;
}
@media (min-width: 1024px) {
  .bc-grid {
    grid-template-columns: minmax(0, 1fr) 380px;
    gap: 32px;
  }
}

.bc-main {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.booking-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(25, 28, 29, 0.08);
  padding: 24px;
  border: 1px solid #edeeef;
}

.booking-card__head {
  margin-bottom: 20px;
}

.booking-card__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.booking-card__num {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e7e8e9;
  color: #191c1d;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Manrope", sans-serif;
}
.booking-card__num--active {
  background: linear-gradient(135deg, #5ea1d8, #7eb8e8);
  color: #003656;
}

.booking-card__title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  font-family: "Manrope", "Inter", sans-serif;
  color: #191c1d;
}

.bc-hint {
  margin: 0 0 16px;
  font-size: 14px;
  color: #40474f;
}

.bc-week-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.bc-week-label {
  font-size: 13px;
  font-weight: 600;
  color: #40474f;
  min-width: 140px;
  text-align: center;
}

.bc-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: #f3f4f5;
  color: #40474f;
  cursor: pointer;
  transition: background 0.2s;
}
.bc-icon-btn:hover:not(:disabled) {
  background: #e7e8e9;
}
.bc-icon-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.bc-icon-btn mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}

.bc-date-strip {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 20px;
}

.bc-date-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 4px;
  border: none;
  border-radius: 8px;
  background: #f3f4f5;
  color: #191c1d;
  cursor: pointer;
  font: inherit;
  transition: background 0.2s, color 0.2s, box-shadow 0.2s;
}
.bc-date-cell:hover:not(:disabled):not(.bc-date-cell--disabled) {
  background: #e7e8e9;
}
.bc-date-cell__wd {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #717880;
}
.bc-date-cell__day {
  font-size: 18px;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}
.bc-date-cell--selected {
  background: #0b6397;
  color: #fff;
  box-shadow: 0 4px 12px rgba(11, 99, 151, 0.35);
}
.bc-date-cell--selected .bc-date-cell__wd {
  color: rgba(255, 255, 255, 0.85);
}
.bc-date-cell--disabled {
  opacity: 0.38;
  cursor: not-allowed;
}

.bc-time-slots-header {
  margin: 16px 0 12px;
}

.bc-time-slots-title {
  margin: 0 0 4px;
  font-size: 0.9375rem;
  font-weight: 700;
  font-family: "Manrope", "Inter", sans-serif;
  color: #191c1d;
}

.bc-time-slots-sub {
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: #40474f;
}

.bc-time-slots-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 0 0 12px;
}

.bc-time-slots-page-label {
  font-size: 13px;
  font-weight: 600;
  color: #40474f;
  min-width: 100px;
  text-align: center;
}

.bc-time-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
@media (min-width: 480px) {
  .bc-time-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.bc-time-chip {
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f3f4f5;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 64px;
}
.bc-time-chip:hover:not(:disabled) {
  border-color: rgba(11, 99, 151, 0.4);
}
.bc-time-chip--selected {
  border: 2px solid #0b6397;
  background: rgba(11, 99, 151, 0.06);
  color: #0b6397;
  font-weight: 700;
}
.bc-time-chip--booked {
  background: rgba(139, 58, 58, 0.06);
  border-color: rgba(139, 58, 58, 0.2);
  color: #5c2a2a;
}
.bc-time-chip--disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.bc-time-chip__time {
  line-height: 1.2;
}

.bc-time-chip__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8b3a3a;
}

.bc-loading {
  font-size: 13px;
  color: #40474f;
  margin-bottom: 12px;
}

.bc-debug {
  margin: 8px 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #5d4037;
  font-size: 12px;
  line-height: 1.45;
}

.bc-session-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.bc-field {
  margin-bottom: 8px;
}

.bc-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #717880;
  margin: 0 0 6px 4px;
}

.bc-contact-grid {
  display: grid;
  gap: 8px;
}
@media (min-width: 600px) {
  .bc-contact-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.bc-upload {
  margin-top: 16px;
}

.bc-upload__hint {
  font-size: 13px;
  color: #40474f;
  margin-bottom: 8px;
}

.bc-file-name {
  font-size: 13px;
  color: #40474f;
  margin: 8px 0 0;
}

/* Create-flow "Cover tab" style upload UI (mirrored) */
.table-wrapper {
  width: 100%;
}

.table-inner {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #f9f9f9;
  min-height: 200px;
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.table-inner img.img-display {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.table-inner video.video-display {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: contain;
}
.table-inner p.text-center {
  color: #606060;
  font-size: 13px;
  text-align: center;
  padding: 20px;
  margin: 0;
}

.upload-icon-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  flex-wrap: nowrap;
  width: 100%;
}
.upload-icon-row .upload-icon-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex-shrink: 0;
}
.upload-icon-row .form-label-wrapper {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
  flex-shrink: 0;
}
.upload-icon-row .form-label-wrapper .required-hint {
  display: block;
  font-size: 11px;
  color: #b45309;
  margin-top: 2px;
}
.upload-icon-row .upload-icon-btn {
  margin-top: 0;
  flex-shrink: 0;
}
@media (max-width: 767px) {
  .upload-icon-row {
    gap: 12px;
    flex-wrap: wrap;
  }
  .upload-icon-row .form-label-wrapper {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }
}

.media-size-recommendation {
  flex: 1;
  min-width: 220px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background-color: #f0f7ff;
  border-radius: 6px;
  border-left: 3px solid #1d67a3;
}
.media-size-recommendation__icon {
  color: #1d67a3;
  font-size: 20px;
  width: 20px;
  height: 20px;
  margin-top: 1px;
  flex-shrink: 0;
}
.media-size-recommendation__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #333;
  font-size: 12px;
  line-height: 1.45;
}
.media-size-recommendation__content strong {
  color: #1d67a3;
  font-size: 13px;
}

.upload-icon-btn {
  width: 56px;
  height: 56px;
  border-radius: 20px;
  background: #e0f2fe;
  color: #0369a1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
  box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);
}
.upload-icon-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);
}
.upload-icon-btn mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
}
.upload-icon-btn input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.bc-mobile-submit {
  margin-top: 24px;
  display: block;
}
@media (min-width: 1024px) {
  .bc-mobile-submit {
    display: none;
  }
}

.bc-summary {
  position: relative;
}

.bc-summary__panel {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 28px 24px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 12px 40px rgba(25, 28, 29, 0.12);
}

@media (min-width: 1024px) {
  .bc-summary__panel {
    position: sticky;
    top: 96px;
  }
}
.bc-summary__title {
  font-family: "Manrope", sans-serif;
  font-weight: 800;
  font-size: 1.35rem;
  margin: 0 0 24px;
  color: #191c1d;
}

.bc-summary__hero {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(192, 199, 208, 0.5);
}

.bc-summary__avatar {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: transparent;
  color: #004b74;
  font-weight: 800;
  font-size: 18px;
  font-family: "Manrope", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.bc-summary__avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.bc-summary__hero-text {
  flex: 1;
  min-width: 0;
}

.bc-summary__eyebrow {
  margin: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #0b6397;
}

.bc-summary__name {
  margin: 4px 0 0;
  font-weight: 700;
  font-size: 15px;
}

.bc-summary__price {
  font-weight: 800;
  font-size: 15px;
  color: #191c1d;
}

.bc-summary__rows {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.bc-summary__row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  font-size: 13px;
}

.bc-summary__row-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #40474f;
}

.bc-summary__ico {
  font-size: 18px;
  width: 18px;
  height: 18px;
  opacity: 0.85;
  flex-shrink: 0;
}

.bc-summary__row-val {
  font-weight: 600;
  text-align: right;
  color: #191c1d;
}

.bc-summary__notice {
  display: flex;
  gap: 10px;
  padding: 14px;
  border-radius: 8px;
  background: rgba(183, 11, 103, 0.08);
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.45;
  color: #5c0031;
}
.bc-summary__notice .bc-summary__notice-icon {
  color: #b70b67;
  flex-shrink: 0;
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.bc-summary__totals {
  margin-bottom: 20px;
}

.bc-summary__total-line {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 8px;
  color: #40474f;
}
.bc-summary__total-line--grand {
  margin-top: 12px;
  padding-top: 16px;
  border-top: 2px dashed #c0c7d0;
  font-size: 16px;
  font-weight: 800;
  font-family: "Manrope", sans-serif;
  color: #191c1d;
}
.bc-summary__total-line--grand span:last-child {
  font-size: 22px;
  color: #0b6397;
}

.bc-btn-primary {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 800;
  font-family: "Manrope", sans-serif;
  color: #fff;
  cursor: pointer;
  background: linear-gradient(135deg, #0b6397, #5ea1d8);
  box-shadow: 0 10px 20px -10px rgba(11, 99, 151, 0.55);
  transition: transform 0.15s ease, box-shadow 0.2s;
}
.bc-btn-primary:hover:not(:disabled) {
  transform: scale(1.01);
}
.bc-btn-primary:active:not(:disabled) {
  transform: scale(0.99);
}
.bc-btn-primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
}
.bc-btn-primary--large {
  padding: 16px 20px;
  font-size: 17px;
}
.bc-btn-primary .bc-btn-primary__ico, .bc-btn-primary__ico {
  font-size: 22px;
  width: 22px;
  height: 22px;
  margin-left: 2px;
}

.bc-summary__secure {
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #717880;
  margin: 16px 0 0;
}

/* Material fields inside session card */
.bc-session ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: rgba(113, 120, 128, 0.38);
}

.bc-session ::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #0b6397;
}

.bc-mat-field {
  width: 100%;
}

.booking-step__empty {
  margin: 0;
  font-size: 14px;
  color: #40474f;
}

.slot-chips-wrap {
  width: 100%;
}

.slot-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: stretch;
  /* Horizontal scroll when many options (mobile) */
  overflow-x: auto;
  padding-bottom: 4px;
  -webkit-overflow-scrolling: touch;
}
.slot-chips-row::-webkit-scrollbar {
  height: 6px;
}
.slot-chips-row::-webkit-scrollbar-thumb {
  background: #c0c7d0;
  border-radius: 4px;
}

.slot-chip {
  flex: 0 0 auto;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #f3f4f5;
  color: #191c1d;
  font: inherit;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.slot-chip:hover:not(:disabled) {
  border-color: rgba(11, 99, 151, 0.35);
  background: #eceeef;
}
.slot-chip:focus-visible {
  outline: 2px solid #0b6397;
  outline-offset: 2px;
}
.slot-chip:disabled, .slot-chip--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #f3f4f5;
}

.slot-chip--selected {
  border: 2px solid #0b6397;
  background: rgba(11, 99, 151, 0.06);
  color: #0b6397;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(11, 99, 151, 0.15);
}

.slot-chip__line {
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
}

.slot-chip__price {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.95;
}

.slot-chip--selected .slot-chip__price {
  color: #0b6397;
}

.slot-chip__off {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #717880;
}

.submit {
  font-family: "Raleway";
  background-color: #5ea1d8;
  font-size: 15px;
  cursor: pointer;
  color: white;
  padding: 10px;
  border-radius: 10px;
}

@media (max-width: 992px) {
  .detail-list {
    display: none;
  }
  .detail-description {
    width: 100%;
    left: 0px;
    padding: 0px 15px;
  }
  .followers-tag {
    flex-wrap: wrap;
  }
  .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .followers-tag .box .text {
    flex: 1;
  }
  .com-record {
    padding: 15px;
  }
  .com-record:after {
    height: 130px;
  }
  .search-container .search-input {
    width: 100%;
  }
  .top-menu-wrap {
    display: none;
  }
  .table-wrap .table-parent {
    display: none;
  }
  .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .mobile-design .common-tile {
    display: flex;
  }
  .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
.clickable-text {
  color: #007bff; /* Link color */
  cursor: pointer; /* Pointer cursor on hover */
  text-decoration: underline; /* Underline text */
}

.clickable-text:hover {
  color: #0056b3; /* Darker shade on hover */
}

.mat-badge-content {
  background: #5ea1d8;
}

.fileExplorer {
  margin-bottom: 0px;
}
.fileExplorer input {
  margin-bottom: 0px;
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 89vh;
  background: #efeeee !important;
}
.main-div .main-content {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 20px !important;
  width: 90%;
  max-width: 600px;
  max-height: 600px;
  overflow-y: auto;
  width: 100%;
  position: relative;
  padding: 0px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 1px solid #ddd;
}
.main-div .main-content .top-head {
  font-size: 22px !important;
  text-align: center;
  padding: 10px;
}

.font16 {
  font-size: 16px !important;
  font-family: "Raleway";
}

.btn-primary {
  background-color: #5ea1d8;
  border: none;
}

.flowbycat {
  background-color: transparent;
}

.hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}

textarea {
  color: rgba(0, 0, 0, 0.54) !important;
}

.img-and-video-sec {
  border-radius: 5px;
  max-height: 300px !important;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px !important;
  border: 1px solid lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
}
.img-and-video-sec video {
  min-height: 274px !important;
}
.img-and-video-sec img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.img-and-video-sec video.video-display {
  max-width: 100%;
  max-height: 250px;
}
.img-and-video-sec p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div {
    min-height: 92vh;
  }
  .main-content {
    width: 75%;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .main-content {
    width: calc(100% - 30px) !important;
    padding: 20px !important;
  }
}
@media (max-width: 460px) {
  .main-div .img-and-video-sec {
    min-height: unset !important;
    max-height: unset !important;
    padding: 30px !important;
  }
  .main-div .img-and-video-sec img.img-display {
    max-height: 100px;
  }
  .main-div .img-and-video-sec .video-display {
    max-height: 100px;
    min-height: 144px !important;
  }
}
.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: -69px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

/* Optional user calendar: manual check hint (no API; same idea as Add to calendar) */
.bc-calendar-manual-hint {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-top: 16px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #c0c7d0;
  background: #f8fafc;
}

.bc-calendar-manual-hint__icon {
  flex-shrink: 0;
  color: #5ea1d8;
  font-size: 26px;
  width: 26px;
  height: 26px;
}

.bc-calendar-manual-hint__body {
  flex: 1;
  min-width: 0;
}
.bc-calendar-manual-hint__body p {
  margin: 0 0 10px;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #333;
}

.bc-calendar-manual-hint__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.bc-calendar-manual-hint__btn mat-icon {
  margin-right: 4px;
  vertical-align: middle;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Optional user calendar: conflict check row + modal */
.bc-conflict-check-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.bc-conflict-check-btn mat-icon {
  margin-right: 4px;
  vertical-align: middle;
}

.bc-calendar-inline-status {
  font-size: 0.8125rem;
  color: #40474f;
}

.bc-calendar-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
  padding: 16px;
}

.bc-calendar-modal {
  position: relative;
  width: min(480px, 100%);
  max-height: min(90vh, 640px);
  overflow-y: auto;
  background: #fff;
  border-radius: 12px;
  padding: 20px 20px 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
}

.bc-calendar-modal__close-x {
  position: absolute;
  top: 8px;
  right: 8px;
}

.bc-calendar-modal__title {
  margin: 0 32px 8px 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.bc-calendar-modal__lead {
  margin: 0 0 14px;
  font-size: 0.875rem;
  color: #40474f;
  line-height: 1.45;
}

.bc-calendar-modal__radios {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}

.bc-calendar-modal__hint {
  margin: 0 0 12px;
  font-size: 0.8125rem;
  color: #40474f;
  line-height: 1.4;
}

.bc-calendar-modal__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bc-calendar-modal__connect {
  margin-top: 4px;
}

.bc-calendar-modal__connected {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #1d5f2c;
  margin-top: 4px;
}

.bc-calendar-modal__connected-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}

.bc-calendar-modal__footer {
  margin-top: 20px;
  padding-top: 12px;
  border-top: 1px solid #c0c7d0;
  display: flex;
  justify-content: flex-end;
}

.bc-calendar-modal .btn-primary,
.bc-calendar-modal .btn-secondary {
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: 44px !important;
  line-height: 1.2 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border: none !important;
  transition: all 0.2s ease !important;
}
.bc-calendar-modal .btn-primary {
  background: #5ea1d8 !important;
  color: #fff !important;
}
.bc-calendar-modal .btn-primary:hover:not(:disabled) {
  background: #4a8fc4 !important;
}
.bc-calendar-modal .btn-secondary {
  background: #f3f4f6 !important;
  color: #374151 !important;
}
.bc-calendar-modal .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb !important;
}

.bc-calendar-checking {
  margin: 12px 0 0;
  font-size: 0.875rem;
  color: #40474f;
}

.bc-calendar-conflict {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #e0a82e;
  background: #fff9e6;
}

.bc-calendar-conflict__icon {
  flex-shrink: 0;
  color: #b8860b;
  font-size: 28px;
  width: 28px;
  height: 28px;
}

.bc-calendar-conflict__body {
  flex: 1;
  min-width: 0;
}
.bc-calendar-conflict__body strong {
  display: block;
  margin-bottom: 6px;
}
.bc-calendar-conflict__body p {
  margin: 0 0 12px;
  font-size: 0.875rem;
  line-height: 1.45;
  color: #333;
}

.bc-calendar-conflict__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

:host-context(body.theme-dark) {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
  /* Week toolbar */
  /* Date strip */
  /* Time slots */
  /* Slot chips (duration selector) */
  /* Order summary panel */
  /* Upload / table inner */
  /* Media recommendation box */
  /* Calendar modal */
  /* Calendar manual hint */
  /* Calendar conflict */
  /* Calendar checking */
  /* Modal button overrides */
  /* Upload icon button */
}
:host-context(body.theme-dark) .bc-page {
  background-color: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .bc-wrap {
  background-color: #0a0c10 !important;
}
:host-context(body.theme-dark) .bc-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-lead {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-meta__k {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-meta__v {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .bc-hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-loading {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-upload__hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-file-name {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .booking-card {
  background: #1e2535 !important;
  border-color: rgba(148, 163, 184, 0.15) !important;
  color: #e5e7eb !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .booking-card__title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .booking-card__num {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .booking-card__num--active {
  background: linear-gradient(135deg, #3b82f6, #60a5fa) !important;
  color: #fff !important;
}
:host-context(body.theme-dark) .bc-main {
  background: transparent !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .tile {
  background: #1e2535 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .bc-week-label,
:host-context(body.theme-dark) .bc-time-slots-page-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-icon-btn {
  background: #2d3748 !important;
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .bc-icon-btn:hover:not(:disabled) {
  background: #374151 !important;
}
:host-context(body.theme-dark) .bc-date-cell {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .bc-date-cell:hover:not(:disabled):not(.bc-date-cell--disabled) {
  background: #374151 !important;
}
:host-context(body.theme-dark) .bc-date-cell__wd {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-date-cell--selected {
  background: #2563eb !important;
  color: #fff !important;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4) !important;
}
:host-context(body.theme-dark) .bc-date-cell--selected .bc-date-cell__wd {
  color: rgba(255, 255, 255, 0.85) !important;
}
:host-context(body.theme-dark) .bc-time-slots-title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-time-slots-sub {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-time-chip {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
  border-color: transparent !important;
}
:host-context(body.theme-dark) .bc-time-chip:hover:not(:disabled) {
  border-color: rgba(96, 165, 250, 0.4) !important;
  background: #374151 !important;
}
:host-context(body.theme-dark) .bc-time-chip--selected {
  border: 2px solid #3b82f6 !important;
  background: rgba(59, 130, 246, 0.12) !important;
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-time-chip--booked {
  background: rgba(239, 68, 68, 0.1) !important;
  border-color: rgba(239, 68, 68, 0.25) !important;
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .bc-time-chip__label {
  color: #fca5a5 !important;
}
:host-context(body.theme-dark) .slot-chip {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
  border-color: transparent !important;
}
:host-context(body.theme-dark) .slot-chip:hover:not(:disabled) {
  border-color: rgba(96, 165, 250, 0.35) !important;
  background: #374151 !important;
}
:host-context(body.theme-dark) .slot-chip--selected {
  border-color: #3b82f6 !important;
  background: rgba(59, 130, 246, 0.12) !important;
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .slot-chip--selected .slot-chip__price {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .slot-chip__off {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-summary__panel {
  background: rgba(30, 37, 53, 0.92) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(148, 163, 184, 0.15) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4) !important;
}
:host-context(body.theme-dark) .bc-summary__title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-summary__hero {
  border-bottom-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .bc-summary__eyebrow {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-summary__name {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-summary__price {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-summary__row-label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-summary__row-val {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .bc-summary__notice {
  background: rgba(183, 11, 103, 0.15) !important;
  color: #fda4d4 !important;
  border: 1px solid rgba(183, 11, 103, 0.3) !important;
}
:host-context(body.theme-dark) .bc-summary__total-line {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-summary__total-line--grand {
  border-top-color: rgba(148, 163, 184, 0.3) !important;
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-summary__total-line--grand span:last-child {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-summary__secure {
  color: #64748b !important;
}
:host-context(body.theme-dark) .table-inner {
  background: #1e2535 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .table-inner p.text-center {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .media-size-recommendation {
  background-color: #1e3a5f !important;
  border-left-color: #3b82f6 !important;
}
:host-context(body.theme-dark) .media-size-recommendation__icon {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .media-size-recommendation__content {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .media-size-recommendation__content strong {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-calendar-modal {
  background: #1e2535 !important;
  color: #e5e7eb !important;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5) !important;
}
:host-context(body.theme-dark) .bc-calendar-modal__title {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .bc-calendar-modal__lead {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-calendar-modal__hint {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-calendar-modal__footer {
  border-top-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .bc-calendar-modal__connected {
  color: #86efac !important;
}
:host-context(body.theme-dark) .bc-calendar-manual-hint {
  background: #1e2535 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .bc-calendar-manual-hint__body p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .bc-calendar-manual-hint__icon {
  color: #60a5fa !important;
}
:host-context(body.theme-dark) .bc-calendar-conflict {
  background: #2d2a1a !important;
  border-color: rgba(202, 138, 4, 0.4) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .bc-calendar-conflict__icon {
  color: #facc15 !important;
}
:host-context(body.theme-dark) .bc-calendar-conflict__body strong {
  color: #fef08a !important;
}
:host-context(body.theme-dark) .bc-calendar-conflict__body p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .bc-calendar-checking {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-calendar-inline-status {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .bc-calendar-modal .btn-secondary {
  background: #2d3748 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .bc-calendar-modal .btn-secondary:hover:not(:disabled) {
  background: #374151 !important;
}
:host-context(body.theme-dark) .upload-icon-btn {
  background: #1e3a5f !important;
  color: #60a5fa !important;
  box-shadow: inset 0 0 0 1px rgba(96, 165, 250, 0.25) !important;
}
:host-context(body.theme-dark) .upload-icon-btn:hover {
  box-shadow: 0 10px 20px rgba(37, 99, 235, 0.3) !important;
}
:host-context(body.theme-dark) .upload-icon-btn mat-icon {
  color: #60a5fa !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/bookconsultations/bookconsultations.component.scss"],"names":[],"mappings":"AAQA;EACE,cAAA;EACA,iBAAA;EACA,mBANe;EAOf,cAAA;EACA,0DAAA;EACA,mCAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,WAAA;AAPF;;AAUA;EACE,uBAAA;EACA,iBAAA;EACA,cAAA;AAPF;;AAUA;EACE,eAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,2CAAA;EACA,gBAAA;EACA,uCAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAjDuB;AA0CzB;;AAUA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAPF;;AAUA;EACE,oBAAA;EACA,sBAAA;EACA,QAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA1EoB;AAmEtB;;AAUA;EACE,gBAAA;EACA,cAAA;AAPF;;AAUA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;AAPF;AASE;EANF;IAOI,2CAAA;IACA,SAAA;EANF;AACF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AANF;;AASA;EACE,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,aAAA;EACA,yBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AANF;;AASA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kCAAA;AANF;AAQE;EACE,qDAAA;EACA,cAAA;AANJ;;AAUA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,eAAA;EACA,cAlJuB;AA2IzB;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAPF;;AAUA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBA/KoB;EAgLpB,cAAA;EACA,eAAA;EACA,2BAAA;AAPF;AASE;EACE,mBAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;AARJ;AAWE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AATJ;;AAaA;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBApNoB;EAqNpB,cAAA;EACA,eAAA;EACA,aAAA;EACA,wDAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;EACA,kCAAA;AAZJ;AAeE;EACE,mBA/OkB;EAgPlB,WAAA;EACA,8CAAA;AAbJ;AAeI;EACE,gCAAA;AAbN;AAiBE;EACE,aAAA;EACA,mBAAA;AAfJ;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,2CAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cA1QuB;AA0PzB;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAhBF;AAkBE;EALF;IAMI,gDAAA;EAfF;AACF;;AAkBA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBA7SoB;EA8SpB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAfF;AAiBE;EACE,oCAAA;AAfJ;AAkBE;EACE,yBAAA;EACA,mCAAA;EACA,cAlUkB;EAmUlB,gBAAA;AAhBJ;AAmBE;EACE,mCAAA;EACA,oCAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;AAlBJ;;AAsBA;EACE,gBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,cA5VuB;EA6VvB,mBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,QAAA;AAnBF;AAqBE;EAJF;IAKI,gDAAA;EAlBF;AACF;;AAqBA;EACE,gBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,cA9YuB;EA+YvB,kBAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAlBF;;AAqBA,uDAAA;AACA;EACE,WAAA;AAlBF;;AAqBA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAlBF;AAoBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AArBF;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;AArBJ;AAwBE;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAtBJ;AAwBI;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AAtBN;AA0BE;EACE,aAAA;EACA,cAAA;AAxBJ;AA2BE;EAtCF;IAuCI,SAAA;IACA,eAAA;EAxBF;EA0BE;IACE,2BAAA;IAAA,sBAAA;EAxBJ;AACF;;AA4BA;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AAzBF;AA2BE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AA1BJ;AA4BI;EACE,cAAA;EACA,eAAA;AA1BN;;AA+BA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,kDAAA;AA5BF;AA8BE;EACE,2BAAA;EACA,+CAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7BJ;AAgCE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AA9BJ;;AAkCA;EACE,gBAAA;EACA,cAAA;AA/BF;AAiCE;EAJF;IAKI,aAAA;EA9BF;AACF;;AAiCA;EACE,kBAAA;AA9BF;;AAiCA;EACE,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,8CAAA;AA9BF;;AAiCA;EACE;IACE,gBAAA;IACA,SAAA;EA9BF;AACF;AAiCA;EACE,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;AA/BF;;AAkCA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA/BF;AAiCE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AA/BJ;;AAmCA;EACE,OAAA;EACA,YAAA;AAhCF;;AAmCA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAvoBoB;AAumBtB;;AAmCA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;AAhCF;;AAmCA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cArqBuB;AAqoBzB;;AAmCA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhCF;AAkCE;EACE,cAhsBe;EAisBf,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAhCJ;;AAoCA;EACE,mBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAntBuB;AAkrBzB;AAmCE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AAjCJ;AAmCI;EACE,eAAA;EACA,cApuBgB;AAmsBtB;;AAsCA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,qDAAA;EACA,qDAAA;EACA,iDAAA;AAnCF;AAqCE;EACE,sBAAA;AAnCJ;AAsCE;EACE,sBAAA;AApCJ;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AArCJ;AAwCE;EACE,kBAAA;EACA,eAAA;AAtCJ;AAyCE;EAEE,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAxCJ;;AA4CA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAzCF;;AA4CA,wCAAA;AACA;EACE,gCAAA;AAzCF;;AA4CA;EACE,cAvyBoB;AA8vBtB;;AA4CA;EACE,WAAA;AAzCF;;AA4CA;EACE,SAAA;EACA,eAAA;EACA,cA7yBuB;AAowBzB;;AA4CA;EACE,WAAA;AAzCF;;AA4CA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,iDAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AAzCF;AA2CE;EACE,WAAA;AAzCJ;AA2CE;EACE,mBAAA;EACA,kBAAA;AAzCJ;;AA6CA;EACE,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAp1BoB;EAq1BpB,cAAA;EACA,aAAA;EACA,eAAA;EACA,+FAAA;AA1CF;AA6CE;EACE,qCAAA;EACA,mBAAA;AA3CJ;AA8CE;EACE,0BAAA;EACA,mBAAA;AA5CJ;AA+CE;EAEE,aAAA;EACA,mBAAA;EACA,mBAz2BkB;AA2zBtB;;AAkDA;EACE,yBAAA;EACA,mCAAA;EACA,cAl3BoB;EAm3BpB,gBAAA;EACA,6CAAA;AA/CF;;AAkDA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA/CF;;AAkDA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;AA/CF;;AAkDA;EACE,cAr4BoB;AAs1BtB;;AAkDA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA/CF;;AAkDA;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA/CF;;AAkDA;EACE;IACE,aAAA;EA/CF;EAkDA;IACE,WAAA;IACA,SAAA;IACA,iBAAA;EAhDF;EAmDA;IACE,eAAA;EAjDF;EAmDE;IACE,YAAA;IACA,WAAA;EAjDJ;EAmDI;IACE,OAAA;EAjDN;EAsDA;IACE,aAAA;EApDF;EAsDE;IACE,aAAA;EApDJ;EA6DE;IACE,WAAA;EA3DJ;EA+DA;IACE,aAAA;EA7DF;EAiEE;IACE,aAAA;EA/DJ;EAmEA;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EAjEF;EAmEE;IACE,gBAAA;IACA,aAAA;EAjEJ;EAmEI;IACE,6BAAA;EAjEN;EAoEI;IACE,yBAAA;EAlEN;EAqEI;IACE,2BAAA;IACA,oDAAA;EAnEN;EAsEI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EApEN;EAsEM;IACE,6BAAA;IACA,sBAAA;EApER;EA2EI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EAzEN;EA2EM;IACE,aAAA;IACA,mBAAA;EAzER;EA6EI;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EA3EN;EA8EI;IACE,aAAA;IACA,uBAAA;EA5EN;EA8EM;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EA5ER;EAgFM;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EA9ER;EAmFE;IACE,aAAA;EAjFJ;EAmFI;IACE,OAAA;IACA,YAAA;EAjFN;AACF;AAwFA;EACE,cAAA,EAAA,eAAA;EACA,eAAA,EAAA,4BAAA;EACA,0BAAA,EAAA,mBAAA;AAtFF;;AAyFA;EACE,cAAA,EAAA,0BAAA;AAtFF;;AAyFA;EACE,mBAAA;AAtFF;;AAwFA;EACE,kBAAA;AArFF;AAsFE;EACE,kBAAA;AApFJ;;AAuFA;EAEI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;AArFJ;AAsFI;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,kBAAA;EACA,sBAAA;AApFN;AAgGI;EACE,0BAAA;EACA,kBAAA;EACA,aAAA;AA9FN;;AAoGA;EAAS,0BAAA;EAA2B,sBAAA;AA/FpC;;AAgGA;EAAc,yBAAA;EAA0B,YAAA;AA3FxC;;AA4FA;EAAW,6BAAA;AAxFX;;AAyFA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAtFF;;AAwFA;EACE,qCAAA;AArFF;;AAuFA;EACE,kBAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AApFF;AAqFE;EACE,4BAAA;AAnFJ;AAqFE;EAME,eAAA;EACA,iBAAA;EACA,mBAAA;AAxFJ;AA0FE;EAAqB,eAAA;EAAiB,iBAAA;AAtFxC;AAuFE;EAAE,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AApFJ;;AAuFA;EACE;IACE,gBAAA;EApFF;EAsFA;IACE,UAAA;EApFF;AACF;AAuFA;EACE;IACE,2BAAA;EArFF;EAsFE;IACE,mCAAA;IACA,wBAAA;EApFJ;AACF;AAwFA;EAEI;IAAoB,4BAAA;IAA8B,4BAAA;IAChD,wBAAA;EArFJ;EAsFI;IACE,iBAAA;EApFN;EAsFI;IACE,iBAAA;IACA,4BAAA;EApFN;AACF;AA4FA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA1FF;;AA4FA;EAGE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,qBAAA;AA5FF;AA8FA;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AA5FF;;AAgGE;EACE,mBAAA;EACA,cAAA;AA7FJ;AA+FE;EACE,WAAA;AA7FJ;;AAiGA,qFAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AA9FF;;AAiGA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA9FF;;AAiGA;EACE,OAAA;EACA,YAAA;AA9FF;AAgGE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AA9FJ;;AAkGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA/FF;;AAkGA;EACE,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA/FF;;AAkGA,uDAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA/FF;;AAkGA;EACE,iBAAA;EACA,sBAAA;AA/FF;;AAkGA;EACE,oBAAA;EACA,cAxxCuB;AAyrCzB;;AAkGA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AA/FF;;AAkGA;EACE,kBAAA;EACA,uBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AA/FF;;AAkGA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AA/FF;;AAkGA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;AA/FF;;AAkGA;EACE,gBAAA;EACA,mBAAA;EACA,cAh0CuB;EAi0CvB,iBAAA;AA/FF;;AAkGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA/FF;;AAkGA;EACE,gBAAA;EACA,oBAAA;EACA,cA90CuB;EA+0CvB,gBAAA;AA/FF;;AAkGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA/FF;;AAkGA;EACE,eAAA;AA/FF;;AAkGA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AA/FF;;AAkGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/FF;;AAkGA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,yBAAA;AA/FF;;AAmGE;;EAEE,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,uBAAA;EACA,oCAAA;AAhGJ;AAmGE;EACE,8BAAA;EACA,sBAAA;AAjGJ;AAmGI;EACE,8BAAA;AAjGN;AAqGE;EACE,8BAAA;EACA,yBAAA;AAnGJ;AAqGI;EACE,8BAAA;AAnGN;;AAwGA;EACE,gBAAA;EACA,mBAAA;EACA,cA35CuB;AAszCzB;;AAwGA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AArGF;;AAwGA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AArGF;;AAwGA;EACE,OAAA;EACA,YAAA;AArGF;AAuGE;EACE,cAAA;EACA,kBAAA;AArGJ;AAwGE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAtGJ;;AA0GA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAvGF;;AA0GA;EACE,8BAAA;EACA,yBAAA;EA8EA,iBAAA;EAeA,eAAA;EAwBA,eAAA;EAoCA,mCAAA;EA0BA,wBAAA;EA4DA,yBAAA;EAUA,6BAAA;EAkBA,mBAAA;EA2BA,yBAAA;EAcA,sBAAA;EAqBA,sBAAA;EASA,2BAAA;EAUA,uBAAA;AAtbF;AA4FE;EACE,oCAAA;EACA,yBAAA;AA1FJ;AA6FE;EACE,oCAAA;AA3FJ;AA8FE;EACE,yBAAA;AA5FJ;AA+FE;EACE,yBAAA;AA7FJ;AAgGE;EACE,yBAAA;AA9FJ;AAiGE;EACE,yBAAA;AA/FJ;AAkGE;EACE,yBAAA;AAhGJ;AAmGE;EACE,yBAAA;AAjGJ;AAoGE;EACE,yBAAA;AAlGJ;AAqGE;EACE,yBAAA;AAnGJ;AAsGE;EACE,yBAAA;AApGJ;AAuGE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;EACA,mDAAA;AArGJ;AAwGE;EACE,yBAAA;AAtGJ;AAyGE;EACE,8BAAA;EACA,yBAAA;AAvGJ;AAyGI;EACE,gEAAA;EACA,sBAAA;AAvGN;AA2GE;EACE,kCAAA;EACA,yBAAA;AAzGJ;AA4GE;EACE,8BAAA;EACA,yBAAA;AA1GJ;AA8GE;;EAEE,yBAAA;AA5GJ;AA+GE;EACE,8BAAA;EACA,yBAAA;AA7GJ;AA+GI;EACE,8BAAA;AA7GN;AAkHE;EACE,8BAAA;EACA,yBAAA;AAhHJ;AAkHI;EACE,8BAAA;AAhHN;AAmHI;EACE,yBAAA;AAjHN;AAoHI;EACE,8BAAA;EACA,sBAAA;EACA,wDAAA;AAlHN;AAoHM;EACE,2CAAA;AAlHR;AAwHE;EACE,yBAAA;AAtHJ;AAyHE;EACE,yBAAA;AAvHJ;AA0HE;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AAxHJ;AA0HI;EACE,gDAAA;EACA,8BAAA;AAxHN;AA2HI;EACE,oCAAA;EACA,+CAAA;EACA,yBAAA;AAzHN;AA4HI;EACE,6CAAA;EACA,gDAAA;EACA,yBAAA;AA1HN;AA8HE;EACE,yBAAA;AA5HJ;AAgIE;EACE,8BAAA;EACA,yBAAA;EACA,oCAAA;AA9HJ;AAgII;EACE,iDAAA;EACA,8BAAA;AA9HN;AAkIE;EACE,gCAAA;EACA,+CAAA;EACA,yBAAA;AAhIJ;AAkII;EACE,yBAAA;AAhIN;AAoIE;EACE,yBAAA;AAlIJ;AAsIE;EACE,6CAAA;EACA,sCAAA;EACA,8CAAA;EACA,sDAAA;EACA,qDAAA;AApIJ;AAuIE;EACE,yBAAA;AArIJ;AAwIE;EACE,wDAAA;AAtIJ;AAyIE;EACE,yBAAA;AAvIJ;AA0IE;EACE,yBAAA;AAxIJ;AA2IE;EACE,yBAAA;AAzIJ;AA4IE;EACE,yBAAA;AA1IJ;AA6IE;EACE,yBAAA;AA3IJ;AA8IE;EACE,+CAAA;EACA,yBAAA;EACA,oDAAA;AA5IJ;AA+IE;EACE,yBAAA;AA7IJ;AA+II;EACE,qDAAA;EACA,yBAAA;AA7IN;AA+IM;EACE,yBAAA;AA7IR;AAkJE;EACE,yBAAA;AAhJJ;AAoJE;EACE,8BAAA;EACA,iDAAA;AAlJJ;AAoJI;EACE,yBAAA;AAlJN;AAuJE;EACE,oCAAA;EACA,qCAAA;AArJJ;AAuJI;EACE,yBAAA;AArJN;AAwJI;EACE,yBAAA;AAtJN;AAwJM;EACE,yBAAA;AAtJR;AA4JE;EACE,8BAAA;EACA,yBAAA;EACA,qDAAA;AA1JJ;AA6JE;EACE,yBAAA;AA3JJ;AA8JE;EACE,yBAAA;AA5JJ;AA+JE;EACE,yBAAA;AA7JJ;AAgKE;EACE,qDAAA;AA9JJ;AAiKE;EACE,yBAAA;AA/JJ;AAmKE;EACE,8BAAA;EACA,iDAAA;AAjKJ;AAoKE;EACE,yBAAA;AAlKJ;AAqKE;EACE,yBAAA;AAnKJ;AAuKE;EACE,8BAAA;EACA,+CAAA;EACA,yBAAA;AArKJ;AAwKE;EACE,yBAAA;AAtKJ;AA0KI;EACE,yBAAA;AAxKN;AA2KI;EACE,yBAAA;AAzKN;AA8KE;EACE,yBAAA;AA5KJ;AA+KE;EACE,yBAAA;AA7KJ;AAiLE;EACE,8BAAA;EACA,yBAAA;AA/KJ;AAiLI;EACE,8BAAA;AA/KN;AAoLE;EACE,8BAAA;EACA,yBAAA;EACA,+DAAA;AAlLJ;AAoLI;EACE,yDAAA;AAlLN;AAqLI;EACE,yBAAA;AAnLN","sourcesContent":["$tab-booking-primary: #0b6397;\n$tab-booking-primary-soft: #5ea1d8;\n$tab-booking-surface: #f3f4f5;\n$tab-booking-border: #c0c7d0;\n$tab-booking-text-muted: #40474f;\n$tab-booking-bg: #f8f9fa;\n$tab-booking-pink: #b70b67;\n\n:host {\n  display: block;\n  min-height: 100vh;\n  background: $tab-booking-bg;\n  color: #191c1d;\n  font-family: \"Inter\", system-ui, -apple-system, sans-serif;\n  -webkit-font-smoothing: antialiased;\n}\n\n.bc-page mat-icon {\n  vertical-align: middle;\n}\n\n.bc-btn-primary mat-icon {\n  color: #fff;\n}\n\n.bc-page {\n  padding: 24px 16px 48px;\n  max-width: 1152px;\n  margin: 0 auto;\n}\n\n.bc-wrap {\n  max-width: 100%;\n}\n\n.bc-header {\n  margin-bottom: 32px;\n}\n\n.bc-title {\n  font-family: \"Manrope\", \"Inter\", sans-serif;\n  font-weight: 800;\n  font-size: clamp(1.75rem, 4vw, 2.25rem);\n  letter-spacing: -0.02em;\n  margin: 0 0 8px;\n  color: #191c1d;\n}\n\n.bc-lead {\n  margin: 0 0 16px;\n  max-width: 42rem;\n  font-size: 15px;\n  line-height: 1.55;\n  color: $tab-booking-text-muted;\n}\n\n.bc-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 24px;\n  font-size: 14px;\n}\n\n.bc-meta__item {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.bc-meta__k {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $tab-booking-primary;\n}\n\n.bc-meta__v {\n  font-weight: 600;\n  color: #191c1d;\n}\n\n.bc-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 28px;\n  align-items: start;\n\n  @media (min-width: 1024px) {\n    grid-template-columns: minmax(0, 1fr) 380px;\n    gap: 32px;\n  }\n}\n\n.bc-main {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n.booking-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(25, 28, 29, 0.08);\n  padding: 24px;\n  border: 1px solid #edeeef;\n}\n\n.booking-card__head {\n  margin-bottom: 20px;\n}\n\n.booking-card__title-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.booking-card__num {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #e7e8e9;\n  color: #191c1d;\n  font-weight: 700;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Manrope\", sans-serif;\n\n  &--active {\n    background: linear-gradient(135deg, $tab-booking-primary-soft, #7eb8e8);\n    color: #003656;\n  }\n}\n\n.booking-card__title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  font-family: \"Manrope\", \"Inter\", sans-serif;\n  color: #191c1d;\n}\n\n.bc-hint {\n  margin: 0 0 16px;\n  font-size: 14px;\n  color: $tab-booking-text-muted;\n}\n\n.bc-week-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.bc-week-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #40474f;\n  min-width: 140px;\n  text-align: center;\n}\n\n.bc-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 8px;\n  background: $tab-booking-surface;\n  color: #40474f;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover:not(:disabled) {\n    background: #e7e8e9;\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n\n  mat-icon {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.bc-date-strip {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  gap: 8px;\n  margin-bottom: 20px;\n}\n\n.bc-date-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 10px 4px;\n  border: none;\n  border-radius: 8px;\n  background: $tab-booking-surface;\n  color: #191c1d;\n  cursor: pointer;\n  font: inherit;\n  transition: background 0.2s, color 0.2s, box-shadow 0.2s;\n\n  &:hover:not(:disabled):not(.bc-date-cell--disabled) {\n    background: #e7e8e9;\n  }\n\n  &__wd {\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #717880;\n  }\n\n  &__day {\n    font-size: 18px;\n    font-weight: 700;\n    font-family: \"Manrope\", sans-serif;\n  }\n\n  &--selected {\n    background: $tab-booking-primary;\n    color: #fff;\n    box-shadow: 0 4px 12px rgba(11, 99, 151, 0.35);\n\n    .bc-date-cell__wd {\n      color: rgba(255, 255, 255, 0.85);\n    }\n  }\n\n  &--disabled {\n    opacity: 0.38;\n    cursor: not-allowed;\n  }\n}\n\n.bc-time-slots-header {\n  margin: 16px 0 12px;\n}\n\n.bc-time-slots-title {\n  margin: 0 0 4px;\n  font-size: 0.9375rem;\n  font-weight: 700;\n  font-family: \"Manrope\", \"Inter\", sans-serif;\n  color: #191c1d;\n}\n\n.bc-time-slots-sub {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.45;\n  color: $tab-booking-text-muted;\n}\n\n.bc-time-slots-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin: 0 0 12px;\n}\n\n.bc-time-slots-page-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #40474f;\n  min-width: 100px;\n  text-align: center;\n}\n\n.bc-time-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n\n  @media (min-width: 480px) {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n.bc-time-chip {\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: $tab-booking-surface;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.2s, background 0.2s, color 0.2s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 64px;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($tab-booking-primary, 0.4);\n  }\n\n  &--selected {\n    border: 2px solid $tab-booking-primary;\n    background: rgba($tab-booking-primary, 0.06);\n    color: $tab-booking-primary;\n    font-weight: 700;\n  }\n\n  &--booked {\n    background: rgba(139, 58, 58, 0.06);\n    border-color: rgba(139, 58, 58, 0.2);\n    color: #5c2a2a;\n  }\n\n  &--disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.bc-time-chip__time {\n  line-height: 1.2;\n}\n\n.bc-time-chip__label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8b3a3a;\n}\n\n.bc-loading {\n  font-size: 13px;\n  color: $tab-booking-text-muted;\n  margin-bottom: 12px;\n}\n\n.bc-debug {\n  margin: 8px 0 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #fff8e1;\n  border: 1px solid #ffe082;\n  color: #5d4037;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.bc-session-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.bc-field {\n  margin-bottom: 8px;\n}\n\n.bc-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #717880;\n  margin: 0 0 6px 4px;\n}\n\n.bc-contact-grid {\n  display: grid;\n  gap: 8px;\n\n  @media (min-width: 600px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.bc-upload {\n  margin-top: 16px;\n}\n\n.bc-upload__hint {\n  font-size: 13px;\n  color: $tab-booking-text-muted;\n  margin-bottom: 8px;\n}\n\n.bc-file-name {\n  font-size: 13px;\n  color: #40474f;\n  margin: 8px 0 0;\n}\n\n/* Create-flow \"Cover tab\" style upload UI (mirrored) */\n.table-wrapper {\n  width: 100%;\n}\n\n.table-inner {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background: #f9f9f9;\n  min-height: 200px;\n  max-height: 400px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n\n  img.img-display {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n\n  video.video-display {\n    width: 100%;\n    height: 100%;\n    max-height: 400px;\n    object-fit: contain;\n  }\n\n  p.text-center {\n    color: #606060;\n    font-size: 13px;\n    text-align: center;\n    padding: 20px;\n    margin: 0;\n  }\n}\n\n.upload-icon-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 16px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  flex-wrap: nowrap;\n  width: 100%;\n\n  .upload-icon-stack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    flex-shrink: 0;\n  }\n\n  .form-label-wrapper {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding: 0;\n    flex-shrink: 0;\n\n    .required-hint {\n      display: block;\n      font-size: 11px;\n      color: #b45309;\n      margin-top: 2px;\n    }\n  }\n\n  .upload-icon-btn {\n    margin-top: 0;\n    flex-shrink: 0;\n  }\n\n  @media (max-width: 767px) {\n    gap: 12px;\n    flex-wrap: wrap;\n\n    .form-label-wrapper {\n      min-width: fit-content;\n    }\n  }\n}\n\n.media-size-recommendation {\n  flex: 1;\n  min-width: 220px;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  background-color: #f0f7ff;\n  border-radius: 6px;\n  border-left: 3px solid #1d67a3;\n\n  &__icon {\n    color: #1d67a3;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    margin-top: 1px;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    color: #333;\n    font-size: 12px;\n    line-height: 1.45;\n\n    strong {\n      color: #1d67a3;\n      font-size: 13px;\n    }\n  }\n}\n\n.upload-icon-btn {\n  width: 56px;\n  height: 56px;\n  border-radius: 20px;\n  background: #e0f2fe;\n  color: #0369a1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  transition: transform 0.2s, box-shadow 0.2s;\n  box-shadow: inset 0 0 0 1px rgba(3, 105, 161, 0.1);\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 20px rgba(3, 105, 161, 0.15);\n  }\n\n  mat-icon {\n    font-size: 28px;\n    width: 28px;\n    height: 28px;\n  }\n\n  input {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n}\n\n.bc-mobile-submit {\n  margin-top: 24px;\n  display: block;\n\n  @media (min-width: 1024px) {\n    display: none;\n  }\n}\n\n.bc-summary {\n  position: relative;\n}\n\n.bc-summary__panel {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 28px 24px;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 12px 40px rgba(25, 28, 29, 0.12);\n}\n\n@media (min-width: 1024px) {\n  .bc-summary__panel {\n    position: sticky;\n    top: 96px;\n  }\n}\n\n.bc-summary__title {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 800;\n  font-size: 1.35rem;\n  margin: 0 0 24px;\n  color: #191c1d;\n}\n\n.bc-summary__hero {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(192, 199, 208, 0.5);\n}\n\n.bc-summary__avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 12px;\n  background: transparent;\n  color: #004b74;\n  font-weight: 800;\n  font-size: 18px;\n  font-family: \"Manrope\", sans-serif;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n}\n\n.bc-summary__hero-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.bc-summary__eyebrow {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: $tab-booking-primary;\n}\n\n.bc-summary__name {\n  margin: 4px 0 0;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.bc-summary__price {\n  font-weight: 800;\n  font-size: 15px;\n  color: #191c1d;\n}\n\n.bc-summary__rows {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.bc-summary__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  font-size: 13px;\n}\n\n.bc-summary__row-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: $tab-booking-text-muted;\n}\n\n.bc-summary__ico {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  opacity: 0.85;\n  flex-shrink: 0;\n}\n\n.bc-summary__row-val {\n  font-weight: 600;\n  text-align: right;\n  color: #191c1d;\n}\n\n.bc-summary__notice {\n  display: flex;\n  gap: 10px;\n  padding: 14px;\n  border-radius: 8px;\n  background: rgba(183, 11, 103, 0.08);\n  margin-bottom: 20px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: #5c0031;\n\n  .bc-summary__notice-icon {\n    color: $tab-booking-pink;\n    flex-shrink: 0;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.bc-summary__totals {\n  margin-bottom: 20px;\n}\n\n.bc-summary__total-line {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: $tab-booking-text-muted;\n\n  &--grand {\n    margin-top: 12px;\n    padding-top: 16px;\n    border-top: 2px dashed #c0c7d0;\n    font-size: 16px;\n    font-weight: 800;\n    font-family: \"Manrope\", sans-serif;\n    color: #191c1d;\n\n    span:last-child {\n      font-size: 22px;\n      color: $tab-booking-primary;\n    }\n  }\n}\n\n.bc-btn-primary {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 800;\n  font-family: \"Manrope\", sans-serif;\n  color: #fff;\n  cursor: pointer;\n  background: linear-gradient(135deg, $tab-booking-primary, $tab-booking-primary-soft);\n  box-shadow: 0 10px 20px -10px rgba(11, 99, 151, 0.55);\n  transition: transform 0.15s ease, box-shadow 0.2s;\n\n  &:hover:not(:disabled) {\n    transform: scale(1.01);\n  }\n\n  &:active:not(:disabled) {\n    transform: scale(0.99);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    transform: none;\n  }\n\n  &--large {\n    padding: 16px 20px;\n    font-size: 17px;\n  }\n\n  .bc-btn-primary__ico,\n  &__ico {\n    font-size: 22px;\n    width: 22px;\n    height: 22px;\n    margin-left: 2px;\n  }\n}\n\n.bc-summary__secure {\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #717880;\n  margin: 16px 0 0;\n}\n\n/* Material fields inside session card */\n.bc-session ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {\n  color: rgba(113, 120, 128, 0.38);\n}\n\n.bc-session ::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {\n  color: $tab-booking-primary;\n}\n\n.bc-mat-field {\n  width: 100%;\n}\n\n.booking-step__empty {\n  margin: 0;\n  font-size: 14px;\n  color: $tab-booking-text-muted;\n}\n\n.slot-chips-wrap {\n  width: 100%;\n}\n\n.slot-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: stretch;\n  /* Horizontal scroll when many options (mobile) */\n  overflow-x: auto;\n  padding-bottom: 4px;\n  -webkit-overflow-scrolling: touch;\n\n  &::-webkit-scrollbar {\n    height: 6px;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #c0c7d0;\n    border-radius: 4px;\n  }\n}\n\n.slot-chip {\n  flex: 0 0 auto;\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  background: $tab-booking-surface;\n  color: #191c1d;\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease,\n    box-shadow 0.2s ease;\n\n  &:hover:not(:disabled) {\n    border-color: rgba($tab-booking-primary, 0.35);\n    background: #eceeef;\n  }\n\n  &:focus-visible {\n    outline: 2px solid $tab-booking-primary;\n    outline-offset: 2px;\n  }\n\n  &:disabled,\n  &--disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n    background: $tab-booking-surface;\n  }\n}\n\n.slot-chip--selected {\n  border: 2px solid $tab-booking-primary;\n  background: rgba($tab-booking-primary, 0.06);\n  color: $tab-booking-primary;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba($tab-booking-primary, 0.15);\n}\n\n.slot-chip__line {\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.slot-chip__price {\n  font-size: 14px;\n  font-weight: 700;\n  opacity: 0.95;\n}\n\n.slot-chip--selected .slot-chip__price {\n  color: $tab-booking-primary;\n}\n\n.slot-chip__off {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #717880;\n}\n\n.submit{\n  font-family: \"Raleway\";\n  background-color: #5ea1d8;\n  font-size: 15px;\n  cursor: pointer;\n  color: white;\n  padding: 10px;\n  border-radius: 10px; \n}\n\n@media(max-width:992px) {\n  .detail-list {\n    display: none;\n  }\n\n  .detail-description {\n    width: 100%;\n    left:0px;\n    padding: 0px 15px;\n  }\n\n  .followers-tag {\n    flex-wrap: wrap;\n\n    .box {\n      margin: 10px;\n      width: 100%;\n\n      .text {\n        flex: 1;\n      }\n    }\n  }\n\n  .com-record {\n    padding: 15px;\n\n    &:after {\n      height: 130px;\n    }\n  }\n\n  .filter {\n    // display: none;\n  }\n\n  .search-container {\n    .search-input {\n      width: 100%;\n    }\n  }\n\n  .top-menu-wrap {\n    display: none;\n  }\n\n  .table-wrap {\n    .table-parent {\n      display: none;\n    }\n  }\n\n  .mobile-design {\n    padding: 20px 10px;\n    background: lightblue;\n    display: block;\n\n    .tile {\n      background: #fff;\n      padding: 10px;\n\n      &>div {\n        border-bottom: 1px solid #ddd;\n      }\n\n      p {\n        color: #5ea1d8 !important;\n      }\n\n      p.bold {\n        font-weight: 700 !important;\n        font-family: Arial, Helvetica, sans-serif !important;\n      }\n\n      .main-title {\n        display: flex;\n        align-items: center;\n        background: #5ea1d8;\n        padding: 10px;\n        margin-bottom: 10px;\n\n        h3 {\n          margin-bottom: 0px !important;\n          color: #fff !important;\n        }\n      }\n\n    }\n\n    .first-tile {\n      div {\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n\n        span {\n          display: flex;\n          align-items: center;\n        }\n      }\n\n      input {\n        position: relative;\n        margin: 0px 10px 0px 0px;\n        width: 20px;\n        height: 20px;\n      }\n\n      .img {\n        display: flex;\n        align-items: flex-start;\n\n        .bundle {\n          width: 30px;\n          margin-right: 10px;\n          height: 30px;\n\n        }\n\n        img {\n          width: 100%;\n          max-height: 80px;\n          object-fit: cover;\n        }\n      }\n    }\n\n    .common-tile {\n      display: flex;\n\n      .title-tile {\n        flex: 1;\n        padding: 3px;\n\n      }\n    }\n\n\n  }\n}\n.clickable-text {\n  color: #007bff; /* Link color */\n  cursor: pointer; /* Pointer cursor on hover */\n  text-decoration: underline; /* Underline text */\n}\n\n.clickable-text:hover {\n  color: #0056b3; /* Darker shade on hover */\n}\n\n.mat-badge-content {\n  background:#5ea1d8;\n}\n.fileExplorer{\n  margin-bottom: 0px;\n  input{\n    margin-bottom: 0px;\n  }\n}\n.main-div{\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 89vh;\n    background: #efeeee !important;\n    .main-content{\n      border-radius: 10px 10px 10px 10px;\n      background: #fff;\n      padding: 20px 20px !important;\n      width: 90%;\n      max-width: 600px;\n      max-height:600px;\n      overflow-y:auto;\n      width: 100%;\n      position: relative;\n      padding: 0px;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      text-align: center;\n      border: 1px solid #ddd;\n      // &::-webkit-scrollbar {\n      //   width: 4px;\n      //   height: 100px;\n      // }\n      // &::-webkit-scrollbar-track {\n      //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n      // }\n      // &::-webkit-scrollbar-thumb {\n      //   background-color: #5ea1d8;\n      //   outline: 1px solid #5ea1d8;\n      // }\n    .top-head {\n      font-size: 22px !important;\n      text-align: center;\n      padding: 10px;\n    }\n\n  }\n}\n\n.font16 {font-size: 16px!important; font-family:\"Raleway\";}\n.btn-primary {background-color:#5ea1d8; border: none;}\n.flowbycat{background-color: transparent;}\n.hide_file {\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  cursor: pointer;\n  right: 0;\n  top: 0;\n  height: 100%;\n  font-size: 24px;\n  width: 100%;\n}\ntextarea{\n  color:rgba(0, 0, 0, 0.54) !important;\n}\n.img-and-video-sec{\n  border-radius: 5px;\n  max-height: 300px !important;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  min-height: 300px !important;\n  border: 1px solid lightgray;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  padding: 15px;\n  video{\n    min-height: 274px !important;\n  }\n  img.img-display {\n  //  position: absolute;\n  //  top: 0;\n  //  left: 0;\n  //  right: 0;\n  //  bottom: 0;\n    max-width: 100%;\n    max-height: 250px;\n    object-fit: contain;\n  }\n  video.video-display {max-width: 100%; max-height: 250px;}\n  p{color: rgba(0, 0, 0, 0.54) !important;\n    text-align: left !important;\n    padding: 10px;\n    line-height: 20px;}\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px){\n  .main-div{\n    min-height:92vh;\n  }\n  .main-content{\n    width:75%;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px){\n  .main-div{\n    background:#fff !important;\n    .main-content{\n      width:calc(100% - 30px) !important;\n      padding: 20px !important;\n    }\n  }\n\n}\n@media(max-width:460px){\n  .main-div{\n    .img-and-video-sec {min-height: unset !important; max-height: unset !important;\n      padding: 30px !important;\n      img.img-display{\n        max-height:100px;\n      }\n      .video-display{\n        max-height:100px;\n        min-height: 144px !important;\n        // margin-top: 30px !important;\n      }\n    }\n  }\n}\n\n\n\n.img-div-left{\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n.img-div-left.small-spinner{\n \n   \n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n \n  top: -69px !important;\n\nimg{\n  width:100px !important;\n  height:100px !important;\n  top:unset !important;\n}\n}\n.quill-wrapper{\n  .fl-left{\n    margin-bottom: 10px;\n    display: block;\n  }\n  quill-editor{\n    width: 100%;\n  }\n}\n\n/* Optional user calendar: manual check hint (no API; same idea as Add to calendar) */\n.bc-calendar-manual-hint {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-top: 16px;\n  padding: 14px;\n  border-radius: 10px;\n  border: 1px solid $tab-booking-border;\n  background: #f8fafc;\n}\n\n.bc-calendar-manual-hint__icon {\n  flex-shrink: 0;\n  color: #5ea1d8;\n  font-size: 26px;\n  width: 26px;\n  height: 26px;\n}\n\n.bc-calendar-manual-hint__body {\n  flex: 1;\n  min-width: 0;\n\n  p {\n    margin: 0 0 10px;\n    font-size: 0.875rem;\n    line-height: 1.45;\n    color: #333;\n  }\n}\n\n.bc-calendar-manual-hint__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.bc-calendar-manual-hint__btn mat-icon {\n  margin-right: 4px;\n  vertical-align: middle;\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n/* Optional user calendar: conflict check row + modal */\n.bc-conflict-check-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.bc-conflict-check-btn mat-icon {\n  margin-right: 4px;\n  vertical-align: middle;\n}\n\n.bc-calendar-inline-status {\n  font-size: 0.8125rem;\n  color: $tab-booking-text-muted;\n}\n\n.bc-calendar-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n  padding: 16px;\n}\n\n.bc-calendar-modal {\n  position: relative;\n  width: min(480px, 100%);\n  max-height: min(90vh, 640px);\n  overflow-y: auto;\n  background: #fff;\n  border-radius: 12px;\n  padding: 20px 20px 16px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);\n}\n\n.bc-calendar-modal__close-x {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n\n.bc-calendar-modal__title {\n  margin: 0 32px 8px 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.bc-calendar-modal__lead {\n  margin: 0 0 14px;\n  font-size: 0.875rem;\n  color: $tab-booking-text-muted;\n  line-height: 1.45;\n}\n\n.bc-calendar-modal__radios {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.bc-calendar-modal__hint {\n  margin: 0 0 12px;\n  font-size: 0.8125rem;\n  color: $tab-booking-text-muted;\n  line-height: 1.4;\n}\n\n.bc-calendar-modal__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.bc-calendar-modal__connect {\n  margin-top: 4px;\n}\n\n.bc-calendar-modal__connected {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.875rem;\n  color: #1d5f2c;\n  margin-top: 4px;\n}\n\n.bc-calendar-modal__connected-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n}\n\n.bc-calendar-modal__footer {\n  margin-top: 20px;\n  padding-top: 12px;\n  border-top: 1px solid $tab-booking-border;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.bc-calendar-modal {\n  .btn-primary,\n  .btn-secondary {\n    padding: 12px 24px !important;\n    border-radius: 8px !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    font-family: \"Raleway\" !important;\n    min-width: 100px !important;\n    height: 44px !important;\n    line-height: 1.2 !important;\n    text-transform: none !important;\n    letter-spacing: normal !important;\n    border: none !important;\n    transition: all 0.2s ease !important;\n  }\n\n  .btn-primary {\n    background: #5ea1d8 !important;\n    color: #fff !important;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4 !important;\n    }\n  }\n\n  .btn-secondary {\n    background: #f3f4f6 !important;\n    color: #374151 !important;\n\n    &:hover:not(:disabled) {\n      background: #e5e7eb !important;\n    }\n  }\n}\n\n.bc-calendar-checking {\n  margin: 12px 0 0;\n  font-size: 0.875rem;\n  color: $tab-booking-text-muted;\n}\n\n.bc-calendar-conflict {\n  display: flex;\n  gap: 12px;\n  margin-top: 16px;\n  padding: 14px;\n  border-radius: 10px;\n  border: 1px solid #e0a82e;\n  background: #fff9e6;\n}\n\n.bc-calendar-conflict__icon {\n  flex-shrink: 0;\n  color: #b8860b;\n  font-size: 28px;\n  width: 28px;\n  height: 28px;\n}\n\n.bc-calendar-conflict__body {\n  flex: 1;\n  min-width: 0;\n\n  strong {\n    display: block;\n    margin-bottom: 6px;\n  }\n\n  p {\n    margin: 0 0 12px;\n    font-size: 0.875rem;\n    line-height: 1.45;\n    color: #333;\n  }\n}\n\n.bc-calendar-conflict__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n:host-context(body.theme-dark) {\n  background: #0a0c10 !important;\n  color: #e5e7eb !important;\n\n  .bc-page {\n    background-color: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  .bc-wrap {\n    background-color: #0a0c10 !important;\n  }\n\n  .bc-title {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-lead {\n    color: #94a3b8 !important;\n  }\n\n  .bc-meta__k {\n    color: #60a5fa !important;\n  }\n\n  .bc-meta__v {\n    color: #e2e8f0 !important;\n  }\n\n  .bc-hint {\n    color: #94a3b8 !important;\n  }\n\n  .bc-loading {\n    color: #94a3b8 !important;\n  }\n\n  .bc-label {\n    color: #94a3b8 !important;\n  }\n\n  .bc-upload__hint {\n    color: #94a3b8 !important;\n  }\n\n  .bc-file-name {\n    color: #94a3b8 !important;\n  }\n\n  .booking-card {\n    background: #1e2535 !important;\n    border-color: rgba(148, 163, 184, 0.15) !important;\n    color: #e5e7eb !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4) !important;\n  }\n\n  .booking-card__title {\n    color: #f1f5f9 !important;\n  }\n\n  .booking-card__num {\n    background: #2d3748 !important;\n    color: #e2e8f0 !important;\n\n    &--active {\n      background: linear-gradient(135deg, #3b82f6, #60a5fa) !important;\n      color: #fff !important;\n    }\n  }\n\n  .bc-main {\n    background: transparent !important;\n    color: #e5e7eb !important;\n  }\n\n  .tile {\n    background: #1e2535 !important;\n    color: #e5e7eb !important;\n  }\n\n  /* Week toolbar */\n  .bc-week-label,\n  .bc-time-slots-page-label {\n    color: #94a3b8 !important;\n  }\n\n  .bc-icon-btn {\n    background: #2d3748 !important;\n    color: #cbd5e1 !important;\n\n    &:hover:not(:disabled) {\n      background: #374151 !important;\n    }\n  }\n\n  /* Date strip */\n  .bc-date-cell {\n    background: #2d3748 !important;\n    color: #e2e8f0 !important;\n\n    &:hover:not(:disabled):not(.bc-date-cell--disabled) {\n      background: #374151 !important;\n    }\n\n    &__wd {\n      color: #94a3b8 !important;\n    }\n\n    &--selected {\n      background: #2563eb !important;\n      color: #fff !important;\n      box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4) !important;\n\n      .bc-date-cell__wd {\n        color: rgba(255, 255, 255, 0.85) !important;\n      }\n    }\n  }\n\n  /* Time slots */\n  .bc-time-slots-title {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-time-slots-sub {\n    color: #94a3b8 !important;\n  }\n\n  .bc-time-chip {\n    background: #2d3748 !important;\n    color: #e2e8f0 !important;\n    border-color: transparent !important;\n\n    &:hover:not(:disabled) {\n      border-color: rgba(96, 165, 250, 0.4) !important;\n      background: #374151 !important;\n    }\n\n    &--selected {\n      border: 2px solid #3b82f6 !important;\n      background: rgba(59, 130, 246, 0.12) !important;\n      color: #60a5fa !important;\n    }\n\n    &--booked {\n      background: rgba(239, 68, 68, 0.1) !important;\n      border-color: rgba(239, 68, 68, 0.25) !important;\n      color: #fca5a5 !important;\n    }\n  }\n\n  .bc-time-chip__label {\n    color: #fca5a5 !important;\n  }\n\n  /* Slot chips (duration selector) */\n  .slot-chip {\n    background: #2d3748 !important;\n    color: #e2e8f0 !important;\n    border-color: transparent !important;\n\n    &:hover:not(:disabled) {\n      border-color: rgba(96, 165, 250, 0.35) !important;\n      background: #374151 !important;\n    }\n  }\n\n  .slot-chip--selected {\n    border-color: #3b82f6 !important;\n    background: rgba(59, 130, 246, 0.12) !important;\n    color: #60a5fa !important;\n\n    .slot-chip__price {\n      color: #60a5fa !important;\n    }\n  }\n\n  .slot-chip__off {\n    color: #94a3b8 !important;\n  }\n\n  /* Order summary panel */\n  .bc-summary__panel {\n    background: rgba(30, 37, 53, 0.92) !important;\n    backdrop-filter: blur(20px) !important;\n    -webkit-backdrop-filter: blur(20px) !important;\n    border: 1px solid rgba(148, 163, 184, 0.15) !important;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4) !important;\n  }\n\n  .bc-summary__title {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-summary__hero {\n    border-bottom-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .bc-summary__eyebrow {\n    color: #60a5fa !important;\n  }\n\n  .bc-summary__name {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-summary__price {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-summary__row-label {\n    color: #94a3b8 !important;\n  }\n\n  .bc-summary__row-val {\n    color: #e2e8f0 !important;\n  }\n\n  .bc-summary__notice {\n    background: rgba(183, 11, 103, 0.15) !important;\n    color: #fda4d4 !important;\n    border: 1px solid rgba(183, 11, 103, 0.3) !important;\n  }\n\n  .bc-summary__total-line {\n    color: #94a3b8 !important;\n\n    &--grand {\n      border-top-color: rgba(148, 163, 184, 0.3) !important;\n      color: #f1f5f9 !important;\n\n      span:last-child {\n        color: #60a5fa !important;\n      }\n    }\n  }\n\n  .bc-summary__secure {\n    color: #64748b !important;\n  }\n\n  /* Upload / table inner */\n  .table-inner {\n    background: #1e2535 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n\n    p.text-center {\n      color: #94a3b8 !important;\n    }\n  }\n\n  /* Media recommendation box */\n  .media-size-recommendation {\n    background-color: #1e3a5f !important;\n    border-left-color: #3b82f6 !important;\n\n    &__icon {\n      color: #60a5fa !important;\n    }\n\n    &__content {\n      color: #cbd5e1 !important;\n\n      strong {\n        color: #60a5fa !important;\n      }\n    }\n  }\n\n  /* Calendar modal */\n  .bc-calendar-modal {\n    background: #1e2535 !important;\n    color: #e5e7eb !important;\n    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.5) !important;\n  }\n\n  .bc-calendar-modal__title {\n    color: #f1f5f9 !important;\n  }\n\n  .bc-calendar-modal__lead {\n    color: #94a3b8 !important;\n  }\n\n  .bc-calendar-modal__hint {\n    color: #94a3b8 !important;\n  }\n\n  .bc-calendar-modal__footer {\n    border-top-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .bc-calendar-modal__connected {\n    color: #86efac !important;\n  }\n\n  /* Calendar manual hint */\n  .bc-calendar-manual-hint {\n    background: #1e2535 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .bc-calendar-manual-hint__body p {\n    color: #cbd5e1 !important;\n  }\n\n  .bc-calendar-manual-hint__icon {\n    color: #60a5fa !important;\n  }\n\n  /* Calendar conflict */\n  .bc-calendar-conflict {\n    background: #2d2a1a !important;\n    border-color: rgba(202, 138, 4, 0.4) !important;\n    color: #e5e7eb !important;\n  }\n\n  .bc-calendar-conflict__icon {\n    color: #facc15 !important;\n  }\n\n  .bc-calendar-conflict__body {\n    strong {\n      color: #fef08a !important;\n    }\n\n    p {\n      color: #cbd5e1 !important;\n    }\n  }\n\n  /* Calendar checking */\n  .bc-calendar-checking {\n    color: #94a3b8 !important;\n  }\n\n  .bc-calendar-inline-status {\n    color: #94a3b8 !important;\n  }\n\n  /* Modal button overrides */\n  .bc-calendar-modal .btn-secondary {\n    background: #2d3748 !important;\n    color: #e2e8f0 !important;\n\n    &:hover:not(:disabled) {\n      background: #374151 !important;\n    }\n  }\n\n  /* Upload icon button */\n  .upload-icon-btn {\n    background: #1e3a5f !important;\n    color: #60a5fa !important;\n    box-shadow: inset 0 0 0 1px rgba(96, 165, 250, 0.25) !important;\n\n    &:hover {\n      box-shadow: 0 10px 20px rgba(37, 99, 235, 0.3) !important;\n    }\n\n    mat-icon {\n      color: #60a5fa !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
